import { GenericDataType, SmsDataType } from 'modules/domains';

export const USER = GenericDataType.User;
export const EMAIL_UNSUBSCRIBE = GenericDataType.UnSubscribe;
export const EMAIL_SUBSCRIBE = GenericDataType.Subscribe;
export const SMS_SEND = SmsDataType.Send;
export const SMS_BOUNCE = SmsDataType.Bounce;
export const SMS_RECEIVED = SmsDataType.Received;
export const SMS_CLICK = SmsDataType.Click;
